var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ESpinner',{attrs:{"size":_vm.size,"dark":_vm.isDarkMode,"color":!_vm.isDarkMode}})
}
var staticRenderFns = []

export { render, staticRenderFns }